module.exports = __webpack_public_path__ + "static/media/anipod02.1efe0565.jpg";